import * as React from 'react';

import type {ListOptionWithCount} from 'shells/select-option-components/option-with-count';

import {useGetAudienceForEntityList} from '../graphql/hooks/use-get-audience-for-entity-list';

import {AddToAudienceButton} from './add-to-audience-button';
import {EditButton} from './edit-button';
import {RemoveFromAudienceButton} from './remove-from-audience-button';

type Props = {
    selectedCount: number;
    onAddToAudience: (audience: ListOptionWithCount, onlyPrimaryContact: boolean) => Promise<any>;
    onRemoveFromAudience: (audienceId: string) => void;
    onEdit: () => void;
    canBulkEdit: boolean;
    audienceId: string;
};

export function ActionsAudience(props: Props) {
    const {audience} = useGetAudienceForEntityList(props.audienceId, 'contacts');

    return (
        <>
            {props.canBulkEdit && <EditButton onClick={props.onEdit}>Edit</EditButton>}
            <AddToAudienceButton
                entityType='contacts'
                selectedCount={props.selectedCount}
                onSubmit={props.onAddToAudience}
                currentAudienceId={props.audienceId}
            />
            <RemoveFromAudienceButton
                isWebFxAudience={Boolean(audience && audience.isWebFX)}
                onRemove={props.onRemoveFromAudience}
                selectedItemCount={props.selectedCount}
                audienceName={audience ? audience.name : ''}
                audienceId={props.audienceId}
            />
        </>
    );
}
